import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Seo from './Seo';
import '../Offers.css';

const LockIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="11" width="18" height="11" rx="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);

export default function Agences() {
  const { t } = useTranslation();

  useEffect(() => { window.scrollTo(0, 0); }, []);

  const trust = t('ag_trust', { returnObjects: true });
  const pains = t('ag_pains', { returnObjects: true });
  const solution = t('ag_solution', { returnObjects: true });
  const scope = t('ag_scope', { returnObjects: true });
  const list1 = t('ag_price_1_list', { returnObjects: true });
  const list2 = t('ag_price_2_list', { returnObjects: true });
  const faq = t('ag_faq', { returnObjects: true });

  return (
    <div className="of_page">
      <Seo title={t('ag_seo_title')} description={t('ag_seo_desc')} path="/agences" />

      {/* ---------------- HERO ---------------- */}
      <section className="of_hero">
        <div className="of_wrap of_hero_grid">
          <div>
            <span className="of_eyebrow">{t('ag_eyebrow')}</span>
            <h1>
              <span className="am">{t('ag_title_1')}</span>
              {t('ag_title_2')}
            </h1>
            <p className="of_hero_sub">{t('ag_sub')}</p>

            <div className="of_cta_row">
              <Link className="of_btn of_btn_primary" to="/contactUs?subject=agency">
                {t('ag_cta1')} <span aria-hidden="true">→</span>
              </Link>
              <a className="of_btn of_btn_ghost" href="#formules">{t('ag_cta2')}</a>
            </div>

            <div className="of_badge" style={{ marginBottom: 22 }}>
              <LockIcon /> {t('ag_badge')}
            </div>

            <div className="of_trust">
              {trust.map((item) => (
                <span key={item}><span className="tick">✓</span>{item}</span>
              ))}
            </div>
          </div>

          {/* schéma marque blanche */}
          <div className="of_panel" aria-hidden="true">
            <div className="of_panel_bar">
              <span className="of_dot r" /><span className="of_dot y" /><span className="of_dot g" />
              <span className="of_panel_title">{t('ag_panel_title')}</span>
            </div>
            <div className="of_panel_body">
              <div className="of_flow">
                <div className="of_flow_box">
                  <div className="t">{t('ag_flow_client_t')}</div>
                  <div className="d">{t('ag_flow_client_d')}</div>
                </div>
                <div className="of_flow_link"><span>↑</span></div>
                <div className="of_flow_box you">
                  <div className="t">{t('ag_flow_agency_t')}</div>
                  <div className="d">{t('ag_flow_agency_d')}</div>
                </div>
                <div className="of_flow_link"><span>{t('ag_flow_link')}</span></div>
                <div className="of_flow_box me">
                  <div className="t">{t('ag_flow_me_t')}</div>
                  <div className="d">{t('ag_flow_me_d')}</div>
                </div>
              </div>
              <div className="of_flow_hidden"><b>◦</b>{t('ag_flow_hidden')}</div>
            </div>
            <p className="of_panel_note">{t('ag_panel_note')}</p>
          </div>
        </div>
      </section>

      {/* ---------------- LE PROBLÈME ---------------- */}
      <section className="of_section alt">
        <div className="of_wrap">
          <div className="of_head">
            <span className="of_eyebrow">{t('ag_pains_eyebrow')}</span>
            <h2 className="of_h2">{t('ag_pains_h2')}</h2>
          </div>
          <div className="of_pains">
            {pains.map((p) => (
              <div className="of_pain" key={p}>
                <span className="of_pain_x">✕</span>
                <p>{p}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ---------------- LA SOLUTION ---------------- */}
      <section className="of_section">
        <div className="of_wrap of_two">
          <div>
            <span className="of_eyebrow">{t('ag_promise_eyebrow')}</span>
            <div className="of_promise" style={{ marginTop: 16 }}>
              <p className="q">{t('ag_promise')}</p>
            </div>
          </div>
          <ul className="of_checks" style={{ marginTop: 8 }}>
            {solution.map((s) => <li key={s}>{s}</li>)}
          </ul>
        </div>
      </section>

      {/* ---------------- PÉRIMÈTRE ---------------- */}
      <section className="of_section alt">
        <div className="of_wrap">
          <div className="of_head center">
            <span className="of_eyebrow">{t('ag_scope_eyebrow')}</span>
            <h2 className="of_h2">{t('ag_scope_h2')}</h2>
          </div>
          <div className="of_grid3">
            {scope.map((s) => (
              <div className="of_card" key={s.title}>
                <div className="of_card_ic" aria-hidden="true">{s.icon}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ---------------- FORMULES ---------------- */}
      <section className="of_section" id="formules">
        <div className="of_wrap">
          <div className="of_head center">
            <span className="of_eyebrow">{t('ag_price_eyebrow')}</span>
            <h2 className="of_h2">{t('ag_price_h2')}</h2>
          </div>

          <div className="of_prices">
            <div className="of_price">
              <span className="of_price_tag">{t('ag_price_1_tag')}</span>
              <div className="amt">{t('ag_price_1_amt')}<small>{t('ag_price_1_sub')}</small></div>
              <p>{t('ag_price_1_desc')}</p>
              <ul className="of_checks">
                {list1.map((i) => <li key={i}>{i}</li>)}
              </ul>
            </div>

            <div className="of_price feat">
              <span className="of_price_tag">{t('ag_price_2_tag')}</span>
              <div className="amt">{t('ag_price_2_amt')}<small>{t('ag_price_2_sub')}</small></div>
              <p>{t('ag_price_2_desc')}</p>
              <ul className="of_checks">
                {list2.map((i) => <li key={i}>{i}</li>)}
              </ul>
            </div>
          </div>

          <div className="of_note" style={{ marginTop: 22 }}>
            <h3>{t('ag_start_h3')}</h3>
            <p>{t('ag_start_p')}</p>
          </div>
        </div>
      </section>

      {/* ---------------- BIO ---------------- */}
      <section className="of_section alt">
        <div className="of_wrap">
          <div className="of_head"><span className="of_eyebrow">{t('ac_bio_eyebrow')}</span></div>
          <div className="of_bio">
            <img className="of_bio_ph" src={process.env.PUBLIC_URL + '/images/younes-pro.jpg'} alt={t('ac_bio_name')} width="92" height="92" loading="lazy" />
            <div>
              <h3>{t('ac_bio_name')}</h3>
              <div className="role">{t('ac_bio_role')}</div>
              <p>{t('ac_bio_p')}</p>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------- FAQ / OBJECTIONS ---------------- */}
      <section className="of_section">
        <div className="of_wrap">
          <div className="of_head center"><h2 className="of_h2">{t('ag_faq_h2')}</h2></div>
          <div className="of_faq">
            {faq.map((f) => (
              <details key={f.q}>
                <summary>{f.q}</summary>
                <p className="ans">{f.a}</p>
              </details>
            ))}
          </div>
        </div>
      </section>

      {/* ---------------- CTA FINAL ---------------- */}
      <section className="of_final">
        <div className="of_wrap of_final_in">
          <h2>{t('ag_final_h2')}</h2>
          <p className="of_lead">{t('ag_final_p')}</p>
          <div className="of_cta_row">
            <Link className="of_btn of_btn_primary" to="/contactUs?subject=agency">
              {t('ag_final_cta')} <span aria-hidden="true">→</span>
            </Link>
            <Link className="of_btn of_btn_ghost" to="/audit-cloud">{t('nav_audit')}</Link>
          </div>
          <p className="of_ps">{t('ag_final_ps')}</p>
        </div>
      </section>
    </div>
  );
}
